var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vehicle-detail',{attrs:{"is-edit":true,"is-new":this.isNew}}),_c('b-row',[_c('DriverHistorie',{attrs:{"vehicle_id":this.id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }